module.exports = __webpack_public_path__ + "static/img/code_yunejia.3fba360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code_yunejia.png
// module id = JIB8
// module chunks = 1